export enum ReportConfigVisibility {
    FULL = "full",
    SUMMARY = "summary",
    SUMMARY_AND_FULL = "summary_full",
}

